import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { ConfigProvider } from 'antd';
import zhCN from 'antd/locale/zh_CN';
import Layout from './components/Layout';
import LoginPage from './pages/Login';
import Dashboard from './pages/Dashboard';
import Upload from './pages/Upload';
import Contracts from './pages/Contracts';
import AuditResult from './pages/AuditResult';
import Templates from './pages/Templates';
import Compare from './pages/Compare';
import AdminUsersPage from './pages/AdminUsers';
import Register from './pages/Register'; 
import './App.css';

const App: React.FC = () => {
  const isLoggedIn = () => {
  const token = localStorage.getItem('zhishentong_token');
  console.log('🔐 检查登录状态:', token ? `已登录 (token: ${token.substring(0, 20)}...)` : '未登录');
  return token !== null;
};

  if (!isLoggedIn()) {
    return (
      <ConfigProvider
        locale={zhCN}
        theme={{
          token: {
            colorPrimary: '#1677ff',
            borderRadius: 6,
          },
        }}
      >
        <Router>
          <Routes>
            <Route path="/login" element={<LoginPage />} />
            <Route path="/register" element={<Register />} /> 
            <Route path="*" element={<Navigate to="/login" replace />} />
          </Routes>
        </Router>
      </ConfigProvider>
    );
  }

  return (
    <ConfigProvider
      locale={zhCN}
      theme={{
        token: {
          colorPrimary: '#1677ff',
          borderRadius: 6,
        },
      }}
    >
      <Router>
        <Routes>
          {/* 主路由 - 使用 Layout 布局 */}
          <Route path="/" element={<Layout />}>
            <Route index element={<Navigate to="/dashboard" replace />} />
            <Route path="dashboard" element={<Dashboard />} />
            <Route path="upload" element={<Upload />} />
            <Route path="contracts" element={<Contracts />} />
            <Route path="audit/:contractId" element={<AuditResult />} />
            <Route path="templates" element={<Templates />} />
            <Route path="compare" element={<Compare />} />
            <Route path="admin/users" element={<AdminUsersPage />} />
          </Route>
          {/* 登录页独立路由 */}
          <Route path="/login" element={<LoginPage />} />
          {/* 404 重定向 */}
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </Router>
    </ConfigProvider>
  );
};

export default App;
